const API_URL = process.env.REACT_APP_BACKEND_URL;

class ApiClient {
  constructor() {
    this.token = localStorage.getItem('token');
  }

  setToken(token) {
    this.token = token;
    if (token) {
      localStorage.setItem('token', token);
    } else {
      localStorage.removeItem('token');
    }
  }

  getToken() {
    return this.token || localStorage.getItem('token');
  }

  async request(endpoint, options = {}) {
    const token = this.getToken();
    const headers = {
      'Content-Type': 'application/json',
      ...options.headers,
    };

    if (token) {
      headers['Authorization'] = `Bearer ${token}`;
    }

    const config = {
      ...options,
      headers,
    };

    try {
      const response = await fetch(`${API_URL}${endpoint}`, config);
      
      if (response.status === 401) {
        this.setToken(null);
        window.location.href = '/login';
        throw new Error('Unauthorized');
      }

      if (!response.ok) {
        const error = await response.json().catch(() => ({ detail: 'Request failed' }));
        throw new Error(error.detail || 'Request failed');
      }

      return await response.json();
    } catch (error) {
      console.error('API Error:', error);
      throw error;
    }
  }

  // Auth
  async signup(email, password) {
    return this.request('/api/auth/signup', {
      method: 'POST',
      body: JSON.stringify({ email, password }),
    });
  }

  async login(email, password) {
    return this.request('/api/auth/login', {
      method: 'POST',
      body: JSON.stringify({ email, password }),
    });
  }

  async getMe() {
    return this.request('/api/auth/me');
  }

  // Classes
  async getClasses() {
    return this.request('/api/classes');
  }

  async createClass(className) {
    return this.request('/api/classes', {
      method: 'POST',
      body: JSON.stringify({ className }),
    });
  }

  async updateClass(classId, className) {
    return this.request(`/api/classes/${classId}`, {
      method: 'PATCH',
      body: JSON.stringify({ className }),
    });
  }

  async deleteClass(classId) {
    return this.request(`/api/classes/${classId}`, {
      method: 'DELETE',
    });
  }

  // Assignments
  async getAssignments(classId) {
    return this.request(`/api/classes/${classId}/assignments`);
  }

  async createAssignment(classId, data) {
    return this.request(`/api/classes/${classId}/assignments`, {
      method: 'POST',
      body: JSON.stringify(data),
    });
  }

  async updateAssignment(assignmentId, data) {
    return this.request(`/api/assignments/${assignmentId}`, {
      method: 'PATCH',
      body: JSON.stringify(data),
    });
  }

  async deleteAssignment(assignmentId) {
    return this.request(`/api/assignments/${assignmentId}`, {
      method: 'DELETE',
    });
  }
}

export default new ApiClient();